import Footer from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FlowkitTemplate/Footer/Footer"
import Hero from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FlowkitTemplate/Hero"
import MissionOverview from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FlowkitTemplate/Mission/MissionOverview"
import MissionTimeline from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FlowkitTemplate/Mission/MissionTimeline"
import NewsFeedGroup from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FlowkitTemplate/NewsFeed/NewsFeedGroup"
import NewsFeedOverview from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FlowkitTemplate/NewsFeed/NewsFeedOverview"
import Overview from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FlowkitTemplate/Overview"

const FlowkitTemplate = () => {
  return (
    <div className="flex flex-col">
      <Hero  />
    <Overview  />
    <div className="grid gap-4 mt-12">
      <MissionOverview  />
      <MissionTimeline  />
    </div>
    <div className="flex flex-col gap-4 lg:gap-8 my-12">
      <NewsFeedOverview  />
      <NewsFeedGroup  />
    </div>

    <Footer  />
    </div>
  )
}

export default FlowkitTemplate